import React, {useContext, useEffect} from "react";
import {FilePond} from "react-filepond";

import axios from "axios";
import '../../../node_modules/filepond/dist/filepond.min.css'
import {TranslateContext} from "../../context/TranslateContext";

export default function NsFileUploader({
                                             files,
                                             setFiles,
                                             endpointPost,
                                             endpointDelete,
                                             handlerPost,
                                             handlerDelete,
                                             allowMultiple,
                                             allowRevert,
                                             labelInvalidField,
                                             acceptedFileTypes,
                                         }) {

    const token = localStorage.getItem('ns-access-token');
    const {translate} = useContext(TranslateContext);

    useEffect(() => {
    }, []);

    return (
        <FilePond
            files={files}
            onupdatefiles={setFiles}
            allowMultiple={allowMultiple}
            allowRevert={allowRevert}
            server=
                {
                    {
                        process: (fieldName, file, metadata, load, error, progress, abort) => {
                            const formData = new FormData();
                            formData.append('file', file, file.name);

                            // related to aborting the request
                            const CancelToken = axios.CancelToken
                            const source = CancelToken.source();

                            // the request itself
                            axios({
                                headers: {
                                    'jwt': token
                                },
                                method: 'post',
                                url: endpointPost,
                                data: formData,
                                cancelToken: source.token,
                                onUploadProgress: (e) => {
                                    progress(e.lengthComputable, e.loaded, e.total);
                                }
                            }).then(response => {
                                let id = response.data;
                                if (handlerPost) {
                                    handlerPost(id)
                                }
                                load(id)
                            }).catch((thrown) => {
                                error(thrown);
                            });

                            // Should expose an abort method so the request can be cancelled
                            return {
                                abort: () => {
                                    source.cancel(translate("Operazione cancellata dall'utente."));
                                }
                            }
                        },
                        revert: (uniqueFileId, load, error) => {
                            axios.delete(endpointDelete + parseInt(uniqueFileId)).then((response) => {
                                if (handlerDelete) {
                                    handlerDelete(response)
                                }
                                load(response)
                            });
                        }
                    }
                }
            labelInvalidField={labelInvalidField}
            acceptedFileTypes={acceptedFileTypes}
            name="files"
            labelIdle={translate('Trascina qui i tuoi file o <span class="filepond--label-action">Cerca</span>')}
        />
    )
}